import React from 'react';
import { useAppearance } from '@fourthwall/appearance';
import { Skeleton } from '@fourthwall/components';
import { BAR_DEFAULT_COLORS, BarChart } from '../../../chartsModule/BarChart/BarChart';
import { LineChart } from '../../../chartsModule/LineChart/LineChart';
import { DEFAULT_SERIES_STYLES } from '../../../chartsModule/LineChart/LineChart.consts';
import { AnalyticsChartLegend } from '../AnalyticsChartLegend/AnalyticsChartLegend';
import * as S from './AnalyticsCard.styled';
import { isBarChartType, isLineChartType, isStatsType } from './AnalyticsCard.types';
import { AnalyticsCardHeading } from './components/AnalyticsCardHeading/AnalyticsCardHeading';
import { StatsTypeAnalyticsCardContent } from './components/StatsTypeAnalyticsCardContent/StatsTypeAnalyticsCardContent';
export const AnalyticsCard = (props) => {
    // TODO: move appearance to props
    const { appearance } = useAppearance();
    const getSpecificHeadingProps = () => {
        if (isLineChartType(props)) {
            return { value: props.value };
        }
        if (isStatsType(props)) {
            return {
                subtitle: 'Sep 22 - Oct 21, 2024',
            };
        }
        return {};
    };
    const renderHeading = () => {
        const commonProps = {
            type: props.type,
            title: props.title,
            titleTooltip: props.titleTooltip,
            reportLink: props.reportLink,
            isLoading: props.isLoading,
            externalSource: props.externalSource,
            formatValue: props.formatValue,
        };
        return React.createElement(AnalyticsCardHeading, { ...commonProps, ...getSpecificHeadingProps() });
    };
    const renderContent = () => {
        if (isLineChartType(props)) {
            return (React.createElement(LineChart, { data: props.data, isLoading: props.isLoading, xAxisFormatter: props.formatXAxis, yAxisFormatter: props.formatYAxis || props.formatValue, appearance: appearance === 'dark' ? 'dark' : 'light' }));
        }
        if (isBarChartType(props)) {
            return (React.createElement(BarChart, { data: props.data, isLoading: props.isLoading, formatValue: props.formatValue }));
        }
        if (isStatsType(props)) {
            return (React.createElement(StatsTypeAnalyticsCardContent, { data: props.data, isLoading: props.isLoading, formatValue: props.formatValue }));
        }
    };
    const renderFooter = () => {
        if (isStatsType(props)) {
            return null;
        }
        if (props.isLoading) {
            return React.createElement(Skeleton.Shape, { width: 160, height: 16 });
        }
        const legendColors = {
            lineChart: [DEFAULT_SERIES_STYLES[0].color, DEFAULT_SERIES_STYLES[1].color],
            barChart: [BAR_DEFAULT_COLORS[0], BAR_DEFAULT_COLORS[1]],
        };
        return (React.createElement(AnalyticsChartLegend, { items: [
                {
                    value: 'Sep 22 - Oct 21, 2024',
                    color: legendColors[props.type][0],
                },
                {
                    value: 'Aug 23 - Sep 21, 2024',
                    color: legendColors[props.type][1],
                },
            ] }));
    };
    return (React.createElement(S.Container, null,
        renderHeading(),
        React.createElement(S.Content, null, renderContent()),
        renderFooter()));
};
